document.addEventListener('click', function (e) {
    if (e.target.closest('.header__burger')) {
        document.querySelector('.menu').classList.add('is-open');
        document.body.classList.add('is-menu-open');
    }
    if (e.target.closest('.menu__close')) {
        document.querySelector('.menu').classList.remove('is-open');
        document.body.classList.remove('is-menu-open');
    }
});

// (function () {
//     var form = document.getElementById('contactForm');
//     if (!form) return;

//     var statusEl = form.querySelector('#status');
//     var submitBtn = form.querySelector('button[type="submit"]');

//     function setStatus(text, kind) {
//         if (!statusEl) return;
//         statusEl.textContent = text;
//         statusEl.className = kind ? 'is-' + kind : '';
//     }

//     form.addEventListener('submit', function (e) {
//         e.preventDefault();
//         setStatus('Sending...', 'pending');
//         if (submitBtn) submitBtn.disabled = true;

//         var data = new FormData(form);

//         fetch('send.php', {
//             method: 'POST',
//             body: data,
//             headers: { 'Accept': 'application/json' }
//         })
//             .then(function (res) {
//                 return res.json().then(function (payload) {
//                     return { ok: res.ok, payload: payload };
//                 });
//             })
//             .then(function (result) {
//                 if (result.ok && result.payload.status === 'success') {
//                     setStatus(result.payload.message || 'Message sent.', 'success');
//                     form.reset();
//                 } else {
//                     setStatus((result.payload && result.payload.message) || 'Something went wrong.', 'error');
//                 }
//             })
//             .catch(function () {
//                 setStatus('Network error. Please try again later.', 'error');
//             })
//             .then(function () {
//                 if (submitBtn) submitBtn.disabled = false;
//             });
//     });
// })();


document.getElementById('contactForm').addEventListener('submit', async function(e) {
  e.preventDefault();
  const form = e.target;
  const formData = new FormData(form);
  const status = document.getElementById('status');

  status.textContent = "";
  status.className = "";

  const email = (formData.get('email') || '').trim();
  const message = (formData.get('message') || '').trim();

  if (!email || !message) {
    status.textContent = "All fields are required";
    status.className = "error";
    return;
  }

  status.textContent = "Sending...";
  status.className = "sending";

  try {
    const response = await fetch('/api/send', {
      method: 'POST',
      body: formData
    });

    const data = await response.json().catch(() => null);

    if (response.ok && data && data.success) {
      status.textContent = "✅ Message sent successfully!";
      status.className = "success";
      form.reset();
    } else {
      const msg = (data && data.message) ? data.message : 'Failed to send message.';
      status.textContent = "❌ " + msg;
      status.className = "error";
    }
  } catch (error) {
    status.textContent = "⚠️ Error: " + (error.message || 'network');
    status.className = "error";
  }
});